// TraitementCongesManager.jsx — Redesign Premium matching other modules
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    Search, Filter, Check, X, User, AlertCircle,
    FileText, ChevronDown, CalendarDays, Loader, Eye,
    Download, RotateCcw,
} from "lucide-react";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../../../../../api";

import {
    getManagerInboxRequest,
    getManagerHistoryRequest,
    managerDecisionRequest,
    clearLeaveRequestMessage,
    exportLeaveRequestsExcelRequest,
} from "../../../../redux/actions/leaveRequestsActions";

import "../TraitementStyles/TraitementAvances.css";
import "../TraitementStyles/TreatmentMesOrdres.css";

const DEMO_MODE = false; // 👉 mets false pour repasser en mode normal

const mockInbox = [
    { id: 1, employeeCode: "EMP-1042", employeeName: "Sara", employeePrenom: "El Fassi", absenceTypeNom: "Congé annuel", dateDebut: "2026-08-10", dateFin: "2026-08-14", duree: 5, commentaire: "Vacances d'été", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-07-28" },
    { id: 2, employeeCode: "EMP-1078", employeeName: "Yassine", employeePrenom: "Amrani", absenceTypeNom: "Congé maladie", dateDebut: "2026-08-05", dateFin: "2026-08-06", duree: 2, commentaire: "Grippe", justificatif: "justificatifs/certif_1078.pdf", justificatifs: ["justificatifs/certif_1078.pdf"], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-04" },
    { id: 3, employeeCode: "EMP-1005", employeeName: "Nadia", employeePrenom: "Rahmouni", absenceTypeNom: "Congé annuel", dateDebut: "2026-08-17", dateFin: "2026-08-21", duree: 5, commentaire: "Voyage à l'étranger", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-01" },
    { id: 4, employeeCode: "EMP-1091", employeeName: "Omar", employeePrenom: "Idrissi", absenceTypeNom: "Congé sans solde", dateDebut: "2026-08-24", dateFin: "2026-08-28", duree: 5, commentaire: "Raison personnelle", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-02" },
    { id: 5, employeeCode: "EMP-1063", employeeName: "Fatima Zahra", employeePrenom: "Bennis", absenceTypeNom: "Congé annuel", dateDebut: "2026-09-01", dateFin: "2026-09-05", duree: 5, commentaire: "Événement familial", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-03" },
    { id: 6, employeeCode: "EMP-1029", employeeName: "Hicham", employeePrenom: "Ouazzani", absenceTypeNom: "Congé annuel", dateDebut: "2026-09-10", dateFin: "2026-09-12", duree: 3, commentaire: "Repos", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-01" },
    { id: 7, employeeCode: "EMP-1057", employeeName: "Khadija", employeePrenom: "Berrada", absenceTypeNom: "Congé maladie", dateDebut: "2026-08-08", dateFin: "2026-08-09", duree: 2, commentaire: "Consultation médicale", justificatif: "justificatifs/certif_1057.pdf", justificatifs: ["justificatifs/certif_1057.pdf"], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-05" },
    { id: 8, employeeCode: "EMP-1013", employeeName: "Anas", employeePrenom: "Chraibi", absenceTypeNom: "Congé annuel", dateDebut: "2026-09-15", dateFin: "2026-09-19", duree: 5, commentaire: "Vacances", justificatif: null, justificatifs: [], status: "PENDING_MANAGER", managerDecision: null, managerDecisionAt: null, managerComment: null, originalDateDebut: null, originalDateFin: null, createdAt: "2026-08-06" },
    { id: 9, employeeCode: "EMP-1024", employeeName: "Ghita", employeePrenom: "Lahlou", absenceTypeNom: "Congé annuel", dateDebut: "2026-07-01", dateFin: "2026-07-10", duree: 8, commentaire: "Voyage", justificatif: null, justificatifs: [], status: "APPROVED", managerDecision: true, managerDecisionAt: "2026-06-26", managerComment: "Approuvé", originalDateDebut: null, originalDateFin: null, createdAt: "2026-06-20" },
    { id: 10, employeeCode: "EMP-1036", employeeName: "Mehdi", employeePrenom: "Kabbaj", absenceTypeNom: "Congé sans solde", dateDebut: "2026-07-15", dateFin: "2026-07-19", duree: 5, commentaire: "Raison personnelle", justificatif: null, justificatifs: [], status: "REJECTED", managerDecision: false, managerDecisionAt: "2026-07-10", managerComment: "Charge de travail trop importante sur cette période.", originalDateDebut: null, originalDateFin: null, createdAt: "2026-07-08" },
];

/* ── SearchableCombobox ── */
const SearchableCombobox = ({ value, onChange, options, placeholder }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState(value || "");
    const wrapperRef = useRef(null);

    useEffect(() => { setQuery(value || ""); }, [value]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredOptions = useMemo(() => {
        if (!query) return options;
        const q = query.toLowerCase();
        return options.filter((o) => o.label.toLowerCase().includes(q));
    }, [options, query]);

    const handleSelect = (opt) => { setQuery(opt.label); onChange(opt.value); setOpen(false); };
    const handleInputChange = (e) => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); };
    const handleClear = () => { setQuery(""); onChange(""); setOpen(false); };

    return (
        <div ref={wrapperRef} style={{ position: "relative", width: "100%" }}>
            <div style={{ position: "relative" }}>
                <input
                    type="text"
                    className="dcInput"
                    style={{ width: "100%", fontSize: "13px", paddingRight: 56 }}
                    placeholder={placeholder}
                    value={query}
                    onChange={handleInputChange}
                    onFocus={() => setOpen(true)}
                />
                <div style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", gap: 2 }}>
                    {query && (
                        <button type="button" onClick={handleClear} style={{ border: "none", background: "none", cursor: "pointer", color: "#9ca3af", padding: 4, lineHeight: 0 }} title={t("Effacer")}>
                            <X size={13} />
                        </button>
                    )}
                    <button type="button" onClick={() => setOpen(o => !o)} style={{ border: "none", background: "none", cursor: "pointer", color: "#9ca3af", padding: 4, lineHeight: 0 }} title={t("Afficher la liste")}>
                        <ChevronDown size={14} />
                    </button>
                </div>
            </div>
            {open && filteredOptions.length > 0 && (
                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.10)", zIndex: 30, maxHeight: 220, overflowY: "auto" }}>
                    {filteredOptions.map((opt) => {
                        const isSelected = opt.value === value;
                        return (
                            <div key={opt.value} onClick={() => handleSelect(opt)}
                                style={{ padding: "8px 12px", fontSize: 13, cursor: "pointer", background: isSelected ? "#eff6ff" : "#fff", color: isSelected ? "#204385" : "#374151", fontWeight: isSelected ? 600 : 400 }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = isSelected ? "#eff6ff" : "#fff")}>
                                {opt.label}
                            </div>
                        );
                    })}
                </div>
            )}
            {open && query && filteredOptions.length === 0 && (
                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.10)", zIndex: 30, padding: "8px 12px", fontSize: 12, color: "#9ca3af" }}>
                    {t("Aucun résultat")}
                </div>
            )}
        </div>
    );
};

const TraitementCongesManager = () => {
    const { t, i18n } = useTranslation();
    const locale = i18n.language === "ar" ? "ar-MA" : i18n.language === "en" ? "en-US" : "fr-FR";
    const dispatch = useDispatch();

    /* ── Redux ──────────────────────────────────────────────── */
    const leaveState = useSelector((state) => state.leaveRequests || {});
    const loading = DEMO_MODE ? false : !!leaveState.loading;
    const _apiError = DEMO_MODE ? null : leaveState.error; // eslint-disable-line no-unused-vars
    const inbox = DEMO_MODE ? mockInbox : (leaveState.managerInbox || []);
    const managerHistory = DEMO_MODE ? [] : (leaveState.managerHistory || []);

    /* ── Local state ─────────────────────────────────────── */
    const [activeTab, setActiveTab] = useState("enCours");
    const [isGlobalDelegationEnabled, setIsGlobalDelegationEnabled] = useState(false);
    const [delegationLoading, setDelegationLoading] = useState(false);
    const [delegationLoaded, setDelegationLoaded] = useState(false);

    // Filtres
    const [filterCollab, setFilterCollab] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterDateDebut, setFilterDateDebut] = useState("");
    const [filterDateFin, setFilterDateFin] = useState("");

    const handleResetFilters = () => {
        setFilterCollab("");
        setFilterType("");
        setFilterDateDebut("");
        setFilterDateFin("");
    };

    const [showDecisionModal, setShowDecisionModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedDemande, setSelectedDemande] = useState(null);
    const [decisionComment, setDecisionComment] = useState("");
    const [pendingDecision, setPendingDecision] = useState(null); // "approve" | "reject"
    const [previewDoc, setPreviewDoc] = useState(null); // { url, name, path }

    useEffect(() => {
        if (!DEMO_MODE) {
            dispatch(getManagerInboxRequest());
            dispatch(getManagerHistoryRequest());
        }
    }, [dispatch]);

    // Garde la liste du manager synchronisée quand un collaborateur soumet
    // une demande depuis une autre session. Le rafraîchissement est arrêté
    // lorsque l'onglet n'est pas visible afin d'éviter des appels inutiles.
    useEffect(() => {
        if (DEMO_MODE) return undefined;

        const refreshInbox = () => {
            if (document.visibilityState === "visible") {
                dispatch(getManagerInboxRequest({ silent: true }));
                dispatch(getManagerHistoryRequest({ silent: true }));
            }
        };

        const intervalId = window.setInterval(refreshInbox, 5_000);
        document.addEventListener("visibilitychange", refreshInbox);
        window.addEventListener("focus", refreshInbox);

        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", refreshInbox);
            window.removeEventListener("focus", refreshInbox);
        };
    }, [dispatch]);

    useEffect(() => {
        const loadDelegationSetting = async () => {
            const token = sessionStorage.getItem("token") || sessionStorage.getItem("accessToken");
            const uid = sessionStorage.getItem("uid");

            try {
                const response = await fetch(`${API_BASE_URL}/api/leave-requests/manager/treatment-delegation`, {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : "",
                        uid,
                    },
                });
                if (!response.ok) throw new Error("Impossible de charger la délégation.");
                const data = await response.json();
                setIsGlobalDelegationEnabled(!!data.enabled);
            } catch (error) {
                console.error("Erreur chargement délégation traitement manager:", error);
            } finally {
                setDelegationLoaded(true);
            }
        };

        loadDelegationSetting();
        const reloadOnFocus = () => {
            if (document.visibilityState === "visible") loadDelegationSetting();
        };
        window.addEventListener("focus", reloadOnFocus);
        document.addEventListener("visibilitychange", reloadOnFocus);
        return () => {
            window.removeEventListener("focus", reloadOnFocus);
            document.removeEventListener("visibilitychange", reloadOnFocus);
        };
    }, []);

    /* ── Helpers ─────────────────────────────────────────────── */
    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return d.toLocaleDateString(locale, {
            day: "2-digit", month: "short", year: "numeric",
        });
    };

    // Detecte un report rejete (dates restaurees, decision negative)
    const isPostponementRejected = (d) =>
        d.originalDateDebut &&
        String(d.status || "").toUpperCase() === "APPROVED" &&
        (d.adminDecision === false || (d.managerDecision === false && d.adminDecision == null));

    const mapDemandeToTab = (demande) => {
        const v = String(demande.status || "").toUpperCase();
        if (v === "PENDING_MANAGER" || v === "POSTPONEMENT_REQUEST") return "enCours";
        if (v === "POSTPONED") return "approuve";
        if (v === "PENDING_ADMIN") return "approuve";
        if (v === "APPROVED") {
            if (isPostponementRejected(demande)) return "rejete";
            return "approuve";
        }
        if (v === "REJECTED") return "rejete";
        if (v === "CANCELLED") return "annule";
        if (demande.managerDecision === true) return "approuve";
        if (demande.managerDecision === false) return "rejete";
        return null;
    };

    // Même source que les avances : demandes en attente et historique manager.
    const allDemandes = useMemo(() => {
        const demandesParId = new Map();
        [...(managerHistory || []), ...(inbox || [])].forEach((demande) => {
            demandesParId.set(demande.id, demande);
        });
        return Array.from(demandesParId.values());
    }, [inbox, managerHistory]);

    const demandes = useMemo(() => {
        return allDemandes.map((d) => ({
            id: d.id,
            matricule: d.employeeCode || "—",
            nom: `${d.employeeName || ""} ${d.employeePrenom || ""}`.trim() || "—",
            directManagerName: d.directManagerName || "—",
            typeConge: d.absenceTypeNom || "—",
            dateDebut: d.dateDebut,
            dateFin: d.dateFin,
            duree: d.duree ?? 0,
            motif: d.commentaire || " - ",
            justificatif: d.justificatif || null,
            statut: mapDemandeToTab(d),
            rawStatus: d.status,
            managerDecision: d.managerDecision ?? null,
            managerDecisionAt: d.managerDecisionAt || null,
            managerComment: d.managerComment || null,
            adminDecision: d.adminDecision ?? null,
            adminComment: d.adminComment || null,
            originalDateDebut: d.originalDateDebut,
            originalDateFin: d.originalDateFin,
            dateDemande: d.createdAt,
            justificatifs: d.justificatifs || [],
        }));
    }, [allDemandes]);

    const getStatutBadge = (demande) => {
        const raw = String(demande.rawStatus || "").toUpperCase();
        // Report en attente
        if (raw === "POSTPONEMENT_REQUEST" || raw === "POSTPONED_REQUEST") {
            return (
                <span className="tavBadge" style={{ backgroundColor: "#f0f9ff", color: "#0c4a6e" }}>
                    En attente de report
                </span>
            );
        }
        // Report approuve
        if (raw === "POSTPONED") {
            return (
                <span className="tavBadge" style={{ backgroundColor: "#d4edda", color: "#155724", display: "flex", alignItems: "center", gap: 4 }}>
                    Approuvee
                    <span style={{ background: "#0369a1", color: "#fff", borderRadius: 4, fontSize: 10, padding: "1px 5px", fontWeight: 700 }}>Apres report</span>
                </span>
            );
        }
        // Report rejete
        if (isPostponementRejected(demande)) {
            return (
                <span className="tavBadge" style={{ backgroundColor: "#f8d7da", color: "#721c24", display: "flex", alignItems: "center", gap: 4 }}>
                    Rejetee
                    <span style={{ background: "#dc2626", color: "#fff", borderRadius: 4, fontSize: 10, padding: "1px 5px", fontWeight: 700 }}>Apres report</span>
                </span>
            );
        }
        const managerStatusConfig = {
            PENDING_MANAGER: { label: "Manager : en attente", bg: "#fff3cd", color: "#856404" },
            PENDING_ADMIN: { label: "Transmis a la RH", bg: "#d1ecf1", color: "#0c5460" },
            APPROVED: { label: "Approuvee", bg: "#d4edda", color: "#155724" },
            REJECTED: { label: "Rejetee", bg: "#f8d7da", color: "#721c24" },
            CANCELLED: { label: "Annulee", bg: "#f3f4f6", color: "#6b7280" },
        };
        const managerStatus = managerStatusConfig[raw];
        if (managerStatus) {
            return (
                <span className="tavBadge" style={{ backgroundColor: managerStatus.bg, color: managerStatus.color }}>
                    {t(managerStatus.label)}
                </span>
            );
        }
        const config = {
            enCours: { label: "En attente", bg: "#fff3cd", color: "#856404" },
            approuve: { label: "Approuvee", bg: "#d4edda", color: "#155724" },
            rejete: { label: "Rejetee", bg: "#f8d7da", color: "#721c24" },
            annule: { label: "Annulee", bg: "#f3f4f6", color: "#6b7280" },
        };
        const c = config[demande.statut] || config.enCours;
        return (
            <span className="tavBadge" style={{ backgroundColor: c.bg, color: c.color }}>
                {t(c.label)}
            </span>
        );
    };

    const getRhStatusBadge = (demande) => {
        const rawStatus = String(demande.rawStatus || demande.status || "").toUpperCase();
        if (demande.managerDecision !== true && !["PENDING_ADMIN", "APPROVED", "REJECTED"].includes(rawStatus)) return null;
        const config = {
            PENDING_ADMIN: { label: demande.managerDecision == null ? "Déléguée à la RH" : "RH : en attente", bg: "#d1ecf1", color: "#0c5460" },
            approved: { label: "RH : approuvée", bg: "#d4edda", color: "#155724" },
            rejected: { label: "RH : rejetée", bg: "#f8d7da", color: "#721c24" },
        };
        const raw = rawStatus;
        const key = demande.adminDecision === true
            ? "approved"
            : demande.adminDecision === false
                ? "rejected"
                : raw;
        const c = config[key];
        return c ? <span className="tavBadge" style={{ backgroundColor: c.bg, color: c.color }}>{t(c.label)}</span> : null;
    };

    const collaborateurOptions = useMemo(() => {
        const map = new Map();
        demandes.forEach((d) => {
            if (d.nom && !map.has(d.nom)) {
                map.set(d.nom, { value: d.nom, label: d.matricule ? `${d.nom} (${d.matricule})` : d.nom });
            }
        });
        return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
    }, [demandes]);

    const typeCongeOptions = useMemo(() => {
        return [...new Set(demandes.map((d) => d.typeConge).filter(Boolean))]
            .sort()
            .map((t) => ({ value: t, label: t }));
    }, [demandes]);

    const filtered = useMemo(() => {
        let list = demandes.filter((d) => d.statut === activeTab);

        if (filterCollab) {
            const val = filterCollab.toLowerCase();
            list = list.filter(
                (d) =>
                    d.nom.toLowerCase().includes(val) ||
                    d.matricule.toLowerCase().includes(val)
            );
        }
        if (filterType) {
            const val = filterType.toLowerCase();
            list = list.filter((d) => (d.typeConge || "").toLowerCase().includes(val));
        }
        if (filterDateDebut) {
            list = list.filter((d) => {
                if (!d.dateDebut) return false;
                return new Date(d.dateDebut).toISOString().split("T")[0] === filterDateDebut;
            });
        }
        if (filterDateFin) {
            list = list.filter((d) => {
                if (!d.dateFin) return false;
                return new Date(d.dateFin).toISOString().split("T")[0] === filterDateFin;
            });
        }
        return list;
    }, [demandes, activeTab, filterCollab, filterType, filterDateDebut, filterDateFin]);

    // Les onglets du manager : En cours, Approuvees, Rejetees, Annulees
    const managerTabs = useMemo(() => [
        { id: "enCours", label: "En cours", count: demandes.filter(d => d.statut === "enCours").length },
        { id: "approuve", label: "Approuvees", count: demandes.filter(d => d.statut === "approuve").length },
        { id: "rejete", label: "Rejetees", count: demandes.filter(d => d.statut === "rejete").length },
        { id: "annule", label: "Annulees", count: demandes.filter(d => d.statut === "annule").length },
    ], [demandes]);

    const typesConges = useMemo(() => [...new Set(demandes.map(d => d.typeConge).filter(Boolean))], [demandes]);

    /* ── Actions ─────────────────────────────────────────────── */
    const handleOpenDecision = (demande, decision) => {
        if (decision === "approve") {
            Swal.fire({
                title: "Confirmation",
                text: "Êtes-vous sûr de vouloir approuver cette demande de congé ?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#10b981",
                cancelButtonColor: "#6b7280",
                confirmButtonText: "Oui, approuver",
                cancelButtonText: "Annuler",
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(managerDecisionRequest({
                        id: demande.id,
                        approved: true,
                        comment: "",
                    }));
                    dispatch(clearLeaveRequestMessage());
                }
            });
            return;
        }

        setSelectedDemande(demande);
        setPendingDecision(decision);
        setDecisionComment("");
        setShowDecisionModal(true);
    };

    const confirmDecision = () => {
        if (!selectedDemande) return;
        const approved = pendingDecision === "approve";
        if (!approved && !decisionComment.trim()) return;

        dispatch(managerDecisionRequest({
            id: selectedDemande.id,
            approved,
            comment: decisionComment || "",
        }));
        dispatch(clearLeaveRequestMessage());
        closeDecision();
    };

    const handleToggleGlobalDelegation = async (enabled) => {
        const result = await Swal.fire({
            title: enabled ? "Activer la délégation ?" : "Désactiver la délégation ?",
            text: enabled
                ? "Les demandes déjà en attente et toutes les nouvelles demandes seront transmises directement à l'Admin RH."
                : "La transmission automatique vers l'Admin RH sera arrêtée.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: enabled ? "#10b981" : "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: enabled ? "Oui, activer" : "Oui, désactiver",
            cancelButtonText: "Annuler",
        });
        if (!result.isConfirmed) return;

        const token = sessionStorage.getItem("token") || sessionStorage.getItem("accessToken");
        const uid = sessionStorage.getItem("uid");

        setDelegationLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/leave-requests/manager/treatment-delegation?enabled=${enabled}`, {
                method: "POST",
                headers: {
                    Authorization: token ? `Bearer ${token}` : "",
                    uid,
                },
            });
            if (!response.ok) throw new Error("Impossible de mettre à jour la délégation.");
            const data = await response.json();
            setIsGlobalDelegationEnabled(!!data.enabled);
            dispatch(getManagerInboxRequest());
            dispatch(getManagerHistoryRequest());
        } catch (error) {
            console.error("Erreur délégation traitement manager:", error);
            Swal.fire({
                icon: "error",
                title: "Erreur",
                text: error.message || "Impossible de mettre à jour la délégation.",
            });
        } finally {
            setDelegationLoading(false);
        }
    };

    const closeDecision = () => {
        setShowDecisionModal(false);
        setDecisionComment("");
        setSelectedDemande(null);
        setPendingDecision(null);
    };

    const handleDownload = (path) => {
        if (!path) return;
        const url = `${API_BASE_URL}/api/files/download?path=${encodeURIComponent(path)}`;
        window.open(url, "_blank");
    };

    const showDetails = (demande) => { setSelectedDemande(demande); setShowDetailsModal(true); };
    const closeDetails = () => { setShowDetailsModal(false); setSelectedDemande(null); };

    const handlePreview = (path) => {
        if (!path) return;
        const url = `${API_BASE_URL}/api/files/download?path=${encodeURIComponent(path)}&inline=true`;
        setPreviewDoc({
            url,
            name: path.split("/").pop(),
            path: path
        });
    };

    const closePreview = () => setPreviewDoc(null);

    /* ── Render ──────────────────────────────────────────────── */
    if (loading && demandes.length === 0) {
        return (
            <div className="tavPage">
                <div className="tavWrap" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 }}>
                    <Loader size={32} className="spin" />
                </div>
            </div>
        );
    }

    return (
        <div className="tavPage">
            <div className="tavWrap">
                {/* Header */}
                <div className="tavHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                    <div>
                        <h1>{t("Traitement des demandes de congés")}</h1>
                        <p>{t("Validez les absences et congés des membres de votre équipe")}</p>
                    </div>
                    <div className="tavDelegationSetting">
                        <div>
                            <div className="tavDelegationSetting__title">{t("Délégation Admin RH")}</div>
                            <div className="tavDelegationSetting__sub">{t("Transmettre mon traitement de congés à l'admin RH")}</div>
                        </div>
                        <label className="tavSwitch" title={t("Délégation Admin RH")}>
                            <input
                                type="checkbox"
                                checked={isGlobalDelegationEnabled}
                                disabled={delegationLoading || !delegationLoaded}
                                onChange={(e) => handleToggleGlobalDelegation(e.target.checked)}
                            />
                            <span />
                        </label>
                    </div>
                </div>

                {/* Filters Panel — style SoldeCongesManagement */}
                <div className="tavCard" style={{ overflow: "visible" }}>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "flex-end",
                            gap: "16px",
                            padding: "4px",
                        }}
                    >
                        {/* Collaborateur / Matricule */}
                        <div style={{ minWidth: 220, flex: "1 1 220px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", display: "block", marginBottom: "4px" }}>
                                {t("Collaborateur / Matricule")}
                            </label>
                            <SearchableCombobox
                                value={filterCollab}
                                onChange={setFilterCollab}
                                options={collaborateurOptions}
                                placeholder={t("Nom ou matricule...")}
                            />
                        </div>

                        {/* Type de congé */}
                        <div style={{ minWidth: 200, flex: "1 1 200px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", display: "block", marginBottom: "4px" }}>
                                {t("Type de congé")}
                            </label>
                            <SearchableCombobox
                                value={filterType}
                                onChange={setFilterType}
                                options={typeCongeOptions}
                                placeholder={t("Rechercher un type...")}
                            />
                        </div>

                        {/* Date début */}
                        <div style={{ minWidth: 160, flex: "1 1 160px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", display: "block", marginBottom: "4px" }}>
                                {t("Date début")}
                            </label>
                            <input
                                type="date"
                                value={filterDateDebut}
                                onChange={(e) => setFilterDateDebut(e.target.value)}
                                className="dcInput"
                                style={{ width: "100%", fontSize: "13px" }}
                            />
                        </div>

                        {/* Date fin */}
                        <div style={{ minWidth: 160, flex: "1 1 160px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", display: "block", marginBottom: "4px" }}>
                                {t("Date fin")}
                            </label>
                            <input
                                type="date"
                                value={filterDateFin}
                                onChange={(e) => setFilterDateFin(e.target.value)}
                                className="dcInput"
                                style={{ width: "100%", fontSize: "13px" }}
                            />
                        </div>

                        {/* Export + Réinitialiser */}
                        <div style={{ display: "flex", gap: 8, flexShrink: 0, alignItems: "flex-end" }}>
                            <button
                                type="button"
                                onClick={handleResetFilters}
                                className="dcBtn dcBtn--outline"
                                style={{ padding: "10px 12px", display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", height: "38px", whiteSpace: "nowrap" }}
                            >
                                <RotateCcw size={14} /> {t("Réinitialiser")}
                            </button>
                            <button
                                type="button"
                                className="dcBtn dcBtn--outline"
                                style={{ padding: "10px 14px", display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", height: "38px", background: "#10b981", color: "white", border: "none", whiteSpace: "nowrap" }}
                                onClick={() => dispatch(exportLeaveRequestsExcelRequest("manager_inbox"))}
                            >
                                <Download size={14} /> {t("Exporter Excel")}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Tabs + Table */}
                <div className="tavCard tavCard--noPad">
                    <div className="tavTabs">
                        {managerTabs.map(tab => (
                            <button key={tab.id} type="button"
                                className={`tavTab ${activeTab === tab.id ? "is-active" : ""}`}
                                onClick={() => setActiveTab(tab.id)}>
                                        {t(tab.label)}
                                <span className={`tavCount ${activeTab === tab.id ? "is-active" : ""}`}>
                                    {tab.count}
                                </span>
                            </button>
                        ))}
                    </div>

                    <div className="tavTableWrap">
                        {filtered.length === 0 ? (
                            <div className="tavEmpty">
                                <AlertCircle size={46} />
                                <div>{t("Aucune demande trouvée")}</div>
                            </div>
                        ) : (
                            <table className="tavTable">
                                <thead>
                                     <tr>
                                         <th>{t("Matricule")}</th><th>{t("Collaborateur")}</th><th>{t("Manager direct")}</th><th>{t("Type")}</th>
                                         <th>{t("Période")}</th>
                                         <th>{t("Durée")}</th><th>{t("Statut")}</th>{activeTab === "rejete" && <th>{t("Motif")}</th>}{activeTab === "approuve" && <th>{t("Statut RH")}</th>}<th className="is-right">{t("Actions")}</th>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     {filtered.map((d) => (
                                         <tr key={d.id} onClick={() => showDetails(d)} style={{ cursor: "pointer" }}>
                                             <td><span className="tavPrimary">{d.matricule}</span></td>
                                             <td><span className="tavPrimary">{d.nom}</span></td>
                                             <td><span className="tavMuted">{d.directManagerName}</span></td>
                                             <td>{d.typeConge}</td>
                                             <td>
                                                 <div className="tavPeriod">
                                                     <span className="tavPrimary">{formatDate(d.dateDebut)} → {formatDate(d.dateFin)}</span>
                                                 </div>
                                                 {d.originalDateDebut && (
                                                     <div style={{ fontSize: 10, color: "#64748b", marginTop: 3 }}>
                                                         <span style={{ textDecoration: "line-through" }}>
                                                             {formatDate(d.originalDateDebut)} → {formatDate(d.originalDateFin)}
                                                         </span>
                                                     </div>
                                                 )}
                                             </td>
                                             <td><b>{d.duree} j</b></td>
                                             <td>{getStatutBadge(d)}</td>
                                             {activeTab === "approuve" && <td>{getRhStatusBadge(d) || "-"}</td>}
                                             {activeTab === "rejete" && (
                                                 <td>
                                                     <span className="tavMuted" style={{ maxWidth: 160, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                         {d.managerComment || d.motif || "—"}
                                                     </span>
                                                 </td>
                                             )}

                                             <td className="is-right" onClick={e => e.stopPropagation()}>
                                                 <div className="tavRowActions">
                                                     {(String(d.rawStatus || "").toUpperCase() === "PENDING_MANAGER" ||
                                                       String(d.rawStatus || "").toUpperCase() === "POSTPONEMENT_REQUEST" ||
                                                       String(d.rawStatus || "").toUpperCase() === "POSTPONED_REQUEST") && (
                                                         <>
                                                             <button type="button" className="tavActionBtn tavActionBtn--ok"
                                                                 onClick={() => handleOpenDecision(d, "approve")} title={t("Approuver")}>
                                                                 <Check size={16} />
                                                             </button>
                                                             <button type="button" className="tavActionBtn tavActionBtn--no"
                                                                 onClick={() => handleOpenDecision(d, "reject")} title={t("Refuser")}>
                                                                 <X size={16} />
                                                             </button>
                                                         </>
                                                     )}
                                                     <button type="button" className="tavActionBtn"
                                                         onClick={() => showDetails(d)} title={t("Détails")}
                                                         style={{ background: "#eff6ff", color: "#3b82f6", border: "1px solid #bfdbfe" }}>
                                                         <Eye size={16} />
                                                     </button>
                                                 </div>
                                             </td>
                                         </tr>
                                     ))}
                                 </tbody>
                             </table>
                        )}
                    </div>
                </div>
            </div>

            {/* Decision Modal */}
            {showDecisionModal && selectedDemande && (
                <div className="tavModal">
                    <div className="tavModal__panel tavModal__panel--small" role="dialog" aria-modal="true">
                        <div className="tavModal__header">
                            <div className="tavModal__headLeft">
                                <div className={`tcModal__icon ${pendingDecision === "reject" ? "tavModal__icon--danger" : ""}`}>
                                    {pendingDecision === "approve" ? <Check size={18} /> : <AlertCircle size={18} />}
                                </div>
                                <div>
                                    <div className="tavModal__title">
                                        {pendingDecision === "approve" ? t("Approuver la demande") : t("Refuser la demande")}
                                    </div>
                                    <div className="tavModal__sub">{selectedDemande.nom} — {selectedDemande.typeConge}</div>
                                </div>
                            </div>
                            <button type="button" className="tavIconBtn" onClick={closeDecision}><X size={18} /></button>
                        </div>
                        <div className="tavModal__body">
                            <label className="tavLabel">Commentaire {pendingDecision === "reject" && <span className="tavReq">*</span>}</label>
                            <textarea
                                className="tavTextarea"
                                rows={4}
                                value={decisionComment}
                                required
                                onChange={e => setDecisionComment(e.target.value)}
                                placeholder={t("Ajouter un commentaire pour le collaborateur...")}
                            />
                            {pendingDecision === "reject" && !decisionComment.trim() && (
                                <p style={{ color: "#ef4444", fontSize: 11, marginTop: 4 }}>{t("Un motif est obligatoire pour un refus.")}</p>
                            )}
                        </div>
                        <div className="tavModal__footer">
                            <button className="tavBtn tavBtn--ghost" onClick={closeDecision}>{t("Annuler")}</button>
                            <button className={`tcBtn ${pendingDecision === "approve" ? "tavBtn--ok" : "tavBtn--danger"}`}
                                onClick={confirmDecision}
                                disabled={pendingDecision === "reject" && !decisionComment.trim()}>
                                Confirmer
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Details Modal */}
            {showDetailsModal && selectedDemande && (
                <div className="tavModal">
                    <div className="tavModal__panel" role="dialog" aria-modal="true">
                        <div className="tavModal__header">
                            <div className="tavModal__headLeft">
                                <div className="tavModal__icon">
                                    <CalendarDays size={18} />
                                </div>
                                <div>
                                    <div className="tavModal__title">{t("Demande de congé")} #{selectedDemande.id}</div>
                                    <div className="tavModal__sub">{t("Demande du")} {formatDate(selectedDemande.dateDebut)}</div>
                                </div>
                            </div>
                            <button type="button" className="tavIconBtn" onClick={closeDetails}>
                                <X size={18} />
                            </button>
                        </div>
                        
                        <div className="tavModal__body">
                            <div className="tavGrid2">
                                {/* Collaborateur */}
                                <div className="tavPanel">
                                    <div className="tavPanel__title">
                                        <User size={16} /> Collaborateur
                                    </div>
                                    <div className="tavKv"><span>{t("Matricule")}</span><b>{selectedDemande.matricule}</b></div><div className="tavKv"><span>{t("Nom")}</span><b>{selectedDemande.nom}</b></div><div className="tavKv"><span>{t("Date de la demande")}</span><b>{formatDate(selectedDemande.dateDemande)}</b></div>
                                </div>

                                {/* Détails congé */}
                                <div className="tavPanel">
                                    <div className="tavPanel__title">
                                        <CalendarDays size={16} /> Détails du congé
                                    </div>
                                    <div className="tavKv"><span>{t("Type")}</span><b>{t(selectedDemande.typeConge, { defaultValue: selectedDemande.typeConge })}</b></div>
                                    <div className="tavKv"><span>{selectedDemande.originalDateDebut ? "Nouvelle Date début" : "Date de début"}</span><b>{formatDate(selectedDemande.dateDebut)}</b></div>
                                    <div className="tavKv"><span>{selectedDemande.originalDateFin ? "Nouvelle Date fin" : "Date de fin"}</span><b>{formatDate(selectedDemande.dateFin)}</b></div>
                                    {selectedDemande.originalDateDebut && (
                                        <div className="tavKv" style={{ background: "#fffbeb", padding: "4px 8px", borderRadius: 6, marginTop: 4 }}>
                                            <span style={{ color: "#92400e" }}>{t("Ancienne période")}</span>
                                            <b style={{ color: "#92400e", textDecoration: "line-through" }}>
                                                {formatDate(selectedDemande.originalDateDebut)} → {formatDate(selectedDemande.originalDateFin)}
                                            </b>
                                        </div>
                                    )}
                                    <div className="tavKv"><span>{t("Durée")}</span><b>{selectedDemande.duree} {t(selectedDemande.duree > 1 ? "jours" : "jour")}</b></div>
                                </div>

                                {/* Motif */}
                                <div className="tavPanel tavPanel--full">
                                    <div className="tavPanel__title">
                                        <FileText size={16} /> Motif de la demande
                                    </div>
                                    <div className="tavText">{selectedDemande.motif || " - "}</div>
                                </div>

                                {/* Justificatifs */}
                                {(selectedDemande.justificatif || (selectedDemande.justificatifs && selectedDemande.justificatifs.length > 0)) && (
                                    <div className="tavPanel tavPanel--full">
                                        <div className="tavPanel__title">
                                            <FileText size={16} /> Justificatifs fournis
                                        </div>
                                        <div className="tnfDocs" style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                                            {selectedDemande.justificatif && !selectedDemande.justificatifs?.includes(selectedDemande.justificatif) && (
                                                <div className="tnfDoc" onClick={() => handlePreview(selectedDemande.justificatif)} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", transition: "all 0.2s" }}>
                                                    <FileText size={18} color="#64748b" />
                                                    <div style={{ flex: 1, fontSize: "13px", fontWeight: "500", color: "#334155" }}>
                                                        {selectedDemande.justificatif.split("/").pop()}
                                                    </div>
                                                    <Eye size={16} color="#3b82f6" />
                                                </div>
                                            )}
                                            {selectedDemande.justificatifs?.map((j, idx) => (
                                                <div key={idx} className="tnfDoc" onClick={() => handlePreview(j)} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", transition: "all 0.2s" }}>
                                                    <FileText size={18} color="#64748b" />
                                                    <div style={{ flex: 1, fontSize: "13px", fontWeight: "500", color: "#334155" }}>
                                                        {j.split("/").pop()}
                                                    </div>
                                                    <Eye size={16} color="#3b82f6" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Décision Manager */}
                                {selectedDemande.managerDecision !== null && (
                                    <div className={`tcPanel tavPanel--full ${selectedDemande.statut === "approuve" ? "tavValidOk" : "tavValidNo"}`}>
                                        <div className="tavPanel__title">
                                            {selectedDemande.statut === "approuve" ? <Check size={16} /> : <X size={16} />}
                                            {selectedDemande.statut === "approuve" ? " Demande approuvée" : " Demande refusée"}
                                        </div>
                                        {selectedDemande.managerDecisionAt && (
                                            <div className="tavKv"><span>{t("Date")}</span><b>{formatDate(selectedDemande.managerDecisionAt)}</b></div>
                                        )}
                                        {selectedDemande.managerComment && (
                                            <div className="tavRejectBox">
                                                <div className="tavRejectLabel">
                                                    {selectedDemande.statut === "approuve" ? "Commentaire" : "Motif du refus"}
                                                </div>
                                                <div className="tavRejectText">{selectedDemande.managerComment}</div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="tavModal__footer">
                            {(String(selectedDemande.rawStatus || "").toUpperCase() === "PENDING_MANAGER" ||
                              String(selectedDemande.rawStatus || "").toUpperCase() === "POSTPONEMENT_REQUEST" ||
                              String(selectedDemande.rawStatus || "").toUpperCase() === "POSTPONED_REQUEST") ? (
                                <>
                                    <button 
                                        className="tavBtn tavBtn--danger"
                                        onClick={() => { closeDetails(); handleOpenDecision(selectedDemande, "reject"); }}
                                        disabled={loading}
                                    >
                                        {t("Refuser")}
                                    </button>
                                    <button 
                                        className="tavBtn tavBtn--ok"
                                        onClick={() => { closeDetails(); handleOpenDecision(selectedDemande, "approve"); }}
                                        disabled={loading}
                                    >
                                        {t("Approuver")}
                                    </button>
                                    <button className="tavBtn tavBtn--ghost" onClick={closeDetails}>{t("Fermer")}</button>
                                </>
                            ) : (
                                <button className="tavBtn tavBtn--ghost" onClick={closeDetails}>{t("Fermer")}</button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Preview Modal */}
            {previewDoc && (
                <div className="tavModal" style={{ zIndex: 10001 }}>
                    <div className="tavModal__panel tavModal__panel--wide" style={{ maxWidth: "90vw", width: "1000px" }}>
                        <div className="tavModal__header">
                            <div className="tavModal__headLeft">
                                <div className="tavModal__icon"><FileText size={18} /></div>
                                <div>
                                    <div className="tavModal__title">{t("Aperçu du document")}</div>
                                    <div className="tavModal__sub">{previewDoc.name}</div>
                                </div>
                            </div>
                            <button type="button" className="tavIconBtn" onClick={closePreview}><X size={18} /></button>
                        </div>
                        <div className="tavModal__body" style={{ height: "75vh", padding: 0, overflow: "hidden", background: "#f1f5f9", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {previewDoc.name.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
                                    <img src={previewDoc.url} alt="Aperçu" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 4, boxShadow: "0 10px 25px -5px rgba(0,0,0,0.1)" }} />
                                </div>
                            ) : previewDoc.name.match(/\.pdf$/i) ? (
                                <iframe src={previewDoc.url} title={t("Aperçu PDF")} width="100%" height="100%" style={{ border: "none" }} />
                            ) : (
                                <div style={{ textAlign: "center", padding: 40 }}>
                                    <AlertCircle size={48} color="#64748b" style={{ marginBottom: 16 }} />
                                    <div style={{ fontWeight: 600, color: "#1e293b", marginBottom: 8 }}>{t("Aperçu non disponible")}</div><p style={{ color: "#64748b", marginBottom: 24 }}>{t("Ce type de fichier ne peut pas être prévisualisé directement.")}</p>
                                    <button className="tavBtn tavBtn--primary" onClick={() => handleDownload(previewDoc.path)}>
                                        <Download size={16} /> Télécharger pour consulter
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="tavModal__footer">
                            <button className="tavBtn tavBtn--ghost" onClick={closePreview}>{t("Fermer")}</button>
                            <button className="tavBtn tavBtn--primary" onClick={() => handleDownload(previewDoc.path)}>
                                <Download size={16} /> Télécharger le document
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TraitementCongesManager;
